module.exports = __webpack_public_path__ + "static/proboard3-21ecb6d2922f04e426cd383b523f9524.png";